import axios from "axios";

export function analyseQnaire(payload, getState) {
    const state = getState();
    const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

    const headers = {
        Authorization: `Bearer ${jwtToken}`,
    };

    return axios
        .put(
            `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/getSimpleMetrics`,
            payload,
            { headers }
        )
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err;
        });
}

export function analyseCustomQuery(payload, getState) {
    const state = getState();
    const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

    const headers = {
        Authorization: `Bearer ${jwtToken}`,
    };

    return axios
        .put(
            `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/getCustomMetrics`,
            payload,
            { headers }
        )
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err;
        });
}

export function crossTableAnalysis(payload, getState) {
    const state = getState();
    const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

    const headers = {
        Authorization: `Bearer ${jwtToken}`,
    };

    return axios
        .put(
            `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/getCrossTable`,
            payload,
            { headers }
        )
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err;
        });
}